import { isNil } from 'lodash';
import { error } from 'State/actions';

import * as types from './types';
import { getFullscreen } from './selectors';

/** KEYBOARD ACTIONS */

export const activateKeyboard = () => {
  return {
    type: types.UI_KEYBOARD_ACTIVE,
  };
};

export const deactivateKeyboard = () => {
  return {
    type: types.UI_KEYBOARD_INACTIVE,
  };
};

/** SIDEBAR MESSAGE ACTIONS */

export const showSidebarMessagesPanel = () => {
  return {
    type: types.UI_SIDEBAR_MESSAGES_SHOW,
  };
};

export const hideSidebarMessagesPanel = () => {
  return {
    type: types.UI_SIDEBAR_MESSAGES_HIDE,
  };
};

export const addSidebarMessage = message => {
  return {
    type: types.UI_SIDEBAR_ADD_MESSAGE,
    payload: message,
  };
};

export const clearSidebarMessages = () => {
  return {
    type: types.UI_SIDEBAR_CLEAR_MESSAGES,
  };
};

export const removeSidebarMessage = id => {
  return {
    type: types.UI_SIDEBAR_REMOVE_MESSAGE,
    payload: id,
  };
};

export const setSidebarDisplay = isOpened => ({
  type: types.UI_SIDEBAR_SET_DISPLAY,
  payload: isOpened,
});

/** UPLOAD PROGRESS */

export const showUploadProgress = () => {
  return {
    type: types.UI_UPLOAD_PROGRESS_SHOW,
  };
};

export const hideUploadProgress = () => {
  return {
    type: types.UI_UPLOAD_PROGRESS_HIDE,
  };
};

export const setUploadProgressTotal = payload => {
  return {
    type: types.UI_UPLOAD_PROGRESS_TOTAL,
    payload: payload,
  };
};

export const setUploadProgressCurrent = payload => {
  return {
    type: types.UI_UPLOAD_PROGRESS_CURRENT,
    payload: payload,
  };
};

export const resetUploadProgress = () => {
  return {
    type: types.UI_RESET_UPLOAD_PROGRESS,
  };
};

export const cancelUpload = () => {
  return {
    type: types.UI_CANCEL_UPLOAD,
  };
};

/** NOTIFICATION SYSTEM */

export const addNotification = notification => {
  return {
    type: types.UI_NOTIFICATION_ADD_MESSAGE,
    payload: notification,
  };
};

export const removeNotification = id => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      await MPWWebApi.postGenericDelete('Notification', id);
      dispatch(removeNotificationMessage(id));
    } catch (err) {}
  };
};

export const removeNotificationsByUser = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      await MPWWebApi.getGeneric(`Notification/DeleteByUser`);
      dispatch(initializeNotifications([]));
    } catch (err) {}
  };
};

export const removeNotificationMessage = id => {
  return {
    type: types.UI_NOTIFICATION_REMOVE_MESSAGE,
    payload: id,
  };
};

export const initializeNotifications = notifications => {
  return {
    type: types.UI_NOTIFICATION_INITIALIZE,
    payload: notifications,
  };
};

export const setHeaderDisplay = isOpened => ({
  type: types.UI_HEADER_SET_DISPLAY,
  payload: isOpened,
});

/** CENTER MESSAGE ACTION **/

export const activateCenterMessages = () => {
  return {
    type: types.UI_CENTER_MESSAGES_ACTIVE,
  };
};

export const deactivateCenterMessages = () => {
  return {
    type: types.UI_CENTER_MESSAGES_INACTIVE,
  };
};

export const showCenterMessages = () => {
  return {
    type: types.UI_CENTER_MESSAGES_SHOW,
  };
};

export const hideCenterMessages = () => {
  return {
    type: types.UI_CENTER_MESSAGES_HIDE,
  };
};

export const addCenterMessage = message => {
  return {
    type: types.UI_CENTER_ADD_MESSAGE,
    payload: message,
  };
};

export const clearCenterMessage = () => {
  return {
    type: types.UI_CENTER_CLEAR_MESSAGE,
  };
};

export const removeCenterMessage = id => {
  return {
    type: types.UI_CENTER_REMOVE_MESSAGE,
    payload: id,
  };
};
export const cancelProcess = processId => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      await MPWWebApi.getGeneric(`Hub/StopHubProcess/${processId}`);
    } catch (err) {
      dispatch(error(types.UI_CANCEL_PROCESS_ERROR, err));
    }
  };
};
export const clearRedirectURL = () => {
  return {
    type: types.UI_CLEAR_REDIRECT_URL,
  };
};

/**
 *
 * @param {Boolean} fullscreen
 * @param {Node} element
 */
export const toggleFullscreen = (
  fullscreen,
  element = document.getElementsByTagName('BODY')[0]
) => (dispatch, getState) => {
  const state = getState();
  const currentFullscreen = getFullscreen(state);
  const nextFullscreen = !isNil(fullscreen) ? fullscreen : !currentFullscreen;
  if (currentFullscreen !== nextFullscreen) {
    if (!currentFullscreen) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }
};

export const setFullscreen = isFullscreen => ({
  type: types.UI_FULLSCREEN,
  payload: isFullscreen,
});



// WEBPACK FOOTER //
// ./src/common/UI/state/actions.js